/**
 * A mapped object containing copies of canvas objects for each cardface,
 * the key is a cardFace's faceId so the objects can be easily mapped to each face
 * @example const photoZones = {'1': [PhotoZoneObject1, PhotoZoneObject2], '2': [PohotoZoneObject1]}
 */
export type CardFaceObjects = {
  [key: string]: fabric.Object[];
};

export const DEFAULT_PROJECT_NAMES = {
  P: 'POD Project',
  D: 'Digital Greetings',
  S: 'S&S Project',
} as const;
